import { render, staticRenderFns } from "./flotRight.vue?vue&type=template&id=96a996ee&scoped=true"
import script from "./flotRight.vue?vue&type=script&lang=js"
export * from "./flotRight.vue?vue&type=script&lang=js"
import style0 from "./flotRight.vue?vue&type=style&index=0&id=96a996ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a996ee",
  null
  
)

export default component.exports